import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import { useAppDispatch } from 'src/services/redux/app/Store';
import { setMerchantTemplateIdReducer, setTemplateNumberReducer } from 'src/services/redux/slices/template/template-slice';
import { useChangeVendorStatus, useGetShowcaseTemplate, useGetVendorStatus } from '../../services';

type getSelectLayoutProps = {
  selectedTemplateId?: number;
};

const SelectLayout = (props: getSelectLayoutProps) => {
  const status: any = useGetVendorStatus();
  const getData = useGetShowcaseTemplate();
  const templateList = getData.data?.templateList;
  const [isShowcase, setIsShowcase] = useState(status?.data?.status?.state);
  const [selectedTemplate, setSelectedTemplate] = useState(0);
  const dispatch = useAppDispatch();
  const { mutateAsync: vendorStatus } = useChangeVendorStatus();
  const vendorId = useSelector<RootState, []>((state) => state.auth.user?.vendor?.id);

  const activeSelectedTemplateId = props.selectedTemplateId ?? selectedTemplate;

  const handleSelectItem = (id: number) => {
    setSelectedTemplate(id);
    dispatch(setMerchantTemplateIdReducer(0));
    dispatch(setTemplateNumberReducer(id));
  };

  const handleChangeStatus = async (vendor: string | undefined) => {
    const payload = {
      state: !isShowcase,
    };
    await vendorStatus({ payload, vendor });
    await status.refetch();
  };

  useEffect(() => {
    setIsShowcase(status?.data?.status?.state);
  }, [status]);

  return (
    <div className="d-flex flex-column w-100 gap-5">
      <h1 className="d-flex align-items-center fw-bolder w-100 border-top border-bottom border-secondary h-70px">Mağaza Sayfası Vitrin Görünümü:</h1>
      <div className="d-flex flex-column gap-4">
        <div className="form-check form-check-custom form-check-solid ">
          <input checked={isShowcase} onChange={() => handleChangeStatus(String(vendorId))} className="form-check-input" type="checkbox" value="" id="showcase-checkbox" />
          <label className="form-check-label fw-bold" htmlFor="showcase-checkbox">
            Satıcı sayfası için vitrin görünümünü etkinleştir.
          </label>
        </div>
        {isShowcase && (
          <div className="d-flex flex-column gap-7">
            <div className="d-flex flex-column">
              <h6 className="fw-bold">Şablon Seçimi:</h6>
              <h6 className="text-muted">Mağaza sayfanızda göstermek istediğiniz sayfa düzenini seçiniz.</h6>
            </div>
            <div className="d-flex gap-8 flex-wrap w-100">
              {templateList ? (
                templateList?.map((template) => (
                  <div className="cursor-pointer" key={template.id} onClick={() => handleSelectItem(template.id)}>
                    <div className="d-flex align-items-center gap-2">
                      <div className="form-check form-check-custom form-check-solid mb-2">
                        <input className="form-check-input" type="radio" value="" id={String(template.id)} checked={activeSelectedTemplateId === template.id} readOnly />
                        <label className="form-check-label fw-bold" htmlFor={String(template.id)}>
                          {template.name}
                        </label>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src={template.thumbnail} alt={template.name} />
                    </div>
                  </div>
                ))
              ) : (
                <div className="fw-bold fs-5 d-flex align-items-center justify-content-center w-100 text-danger">Şablonlar yüklenirken bir sorun oluştu!</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectLayout;
